import { render, staticRenderFns } from "./ForgetPasswordShow.vue?vue&type=template&id=772afc24&scoped=true"
import script from "./ForgetPasswordShow.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordShow.vue?vue&type=script&lang=js"
import style0 from "./ForgetPasswordShow.vue?vue&type=style&index=0&id=772afc24&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772afc24",
  null
  
)

export default component.exports